<!-- 基本信息 -->
<template>
  <div class="basic-info-view">
    <el-form :rules="rules">
      <el-form-item label="解决方案名称：" label-width="190px">
        <el-input
          v-model="queryParams.solutionName"
          style="width: 700px"
          placeholder="请输入解决方案名称"
        />
      </el-form-item>

      <el-form-item label="解决方案类型：" label-width="190px">
        <SelectTreeRadio
          apiName="getDicRadioButton"
          :params="{ code: '051' }"
          resultType="values"
          vFeild="codeId"
          lFeild="codeName"
          storageKey="solutionCategory"
          v-model="queryParams.solutionType"
          :isCheckBoxButton="false"
          :isTree="false"
        ></SelectTreeRadio>
      </el-form-item>

      <el-form-item label="解决方案配图：" label-width="190px">
        <MyImageUpload
          :limitCount="5"
          :upLoadImgList.sync="queryParams.solutionIllustrationList"
          @upLoadImgList="
            e => onChangeUpLoadImgList('solutionIllustrationList', e)
          "
        ></MyImageUpload>
      </el-form-item>

      <el-form-item label="解决方案展示链接:" label-width="190px" prop="productUrl">
        <el-link
          :href="queryParams.solutionDisplayLink"
          target="_blank"
          :underline="false"
          >{{ queryParams.solutionDisplayLink }}</el-link
        >

        <span class="edit-link-btn">
          <i
            class="jr-iconjr-icon-edit1"
            style="margin-left: 24px;"
            @click="isLinkShow = true"
          ></i>
        </span>

        <div class="input_button" v-if="isLinkShow">
          <el-input
            v-model="queryParams.solutionDisplayLink"
            style="width: 470px"
          />
          <el-button
            type="primary"
            style="height: 40px; margin-left: 24px"
            @click="isLinkShow = false"
            >保存</el-button
          >
        </div>
      </el-form-item>

      <el-form-item label="封面图：" label-width="190px">
        <MyImageUpload
          :uploadLimit="1"
          :upLoadImgList.sync="queryParams.coverImage"
          @upLoadImgList="e => onChangeUpLoadImgList('coverImage', e)"
        ></MyImageUpload>
      </el-form-item>

      <el-form-item label="分享图：" label-width="190px">
        <MyImageUpload
          :uploadLimit="1"
          :upLoadImgList.sync="queryParams.shareImage"
          @upLoadImgList="e => onChangeUpLoadImgList('shareImage', e)"
        ></MyImageUpload>
      </el-form-item>

      <el-form-item label="交付类型：" label-width="190px">
        <SelectTreeRadio
          :isTree="true"
          apiName="getDicRadioButton"
          :params="{ code: '008' }"
          resultType="values"
          vFeild="codeId"
          lFeild="codeName"
          storageKey="deliverCategory"
          v-model="queryParams.deliveryTypeList"
          :isCheckBoxButton="false"
          :isRadioFirstLevel="false"
        ></SelectTreeRadio>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
// components
import MyImageUpload from "@/components/MyImageUpload/index.vue";
// 多级标签
import SelectTreeRadio from "@/components/SelectTreeRadio.vue";

// api
import { getSolutionById, updateSolutionBasic } from "@/api/solvePlan.js";

export default {
  components: {
    MyImageUpload,
    SelectTreeRadio
  },
  props: {
    queryParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    //这里存放数据
    return {
      rules: {},
      isLinkShow: false,
      options: []
    };
  },
  methods: {
    getInfo() {
      getSolutionById({ id: this.$route.query.companyCode }).then(res => {
        if (res.code == 200 && res.data) {
          for (let key in res.data) {
            if (["coverImage", "shareImage"].includes(key)) {
              if (!Array.isArray(res.data[key])) {
                if (res.data[key]) {
                  this.queryParams[key] = [res.data[key]];
                } else {
                  this.queryParams[key] = [];
                }
              } else {
                this.queryParams[key] = res.data[key];
              }
            } else {
              this.queryParams[key] = res.data[key];
            }
          }
        }
      });
    },
    submit() {
      const params = {
        ...this.queryParams,
        coverImage: this.queryParams.coverImage.join(","),
        shareImage: this.queryParams.shareImage.join(",")
      };

      this.$modal.loading('正在保存数据，请稍候...');

      updateSolutionBasic(params).then(res => {
        if (res.code === 200) {
          this.$message.success("编辑成功");
        } else {
          this.$message.error(res.msg);
        }
      }).finally(() => {
        this.$modal.closeLoading();
      });
    },
    onChangeUpLoadImgList(fieldName, val) {
      this.queryParams[fieldName] = val.map(item => item.url);
    }
  }
};
</script>

<style scoped lang="less">
/deep/.el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
}

/deep/.el-upload-list__item {
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
}

/deep/.el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
}
</style>